import { DiwaAPI } from './client'

/** Mirrors GET /dashboard in products/diwa/src/diwa/pipeline/router.py.
 *  `plan` / `plan_name` come from the ONE entitlements catalog (keeper vocabulary)
 *  — the same identity /billing/plan and the Pricing page sell. */
export interface Dashboard {
  people: {
    total: number
    warm: number
    enriched: number
    avg_confidence: number | null
  }
  plan: string
  plan_name: string
}

export class DashboardAPI {
  private api: DiwaAPI

  constructor(baseUrl: string) {
    this.api = new DiwaAPI(baseUrl)
  }

  get(): Promise<Dashboard> {
    return this.api.get<Dashboard>('/dashboard')
  }
}
